import type { I18NMessages } from '@atlaskit/intl-messages-provider/types';
import { logException } from '@atlassian/atlassian-studio-observability';

type Catalog = Promise<{ default: I18NMessages }>;
type CatalogMerger = (...catalogs: Catalog[]) => Promise<{ default: I18NMessages }>;

export const createCatalogMerger = (defaultMessages: I18NMessages): CatalogMerger => {
	return async (...catalogs: Catalog[]): Promise<{ default: I18NMessages }> => {
		const results = await Promise.allSettled(catalogs);

		for (const result of results) {
			if (result.status === 'rejected') {
				const error =
					result.reason instanceof Error ? result.reason : new Error(String(result.reason));
				logException(error, {
					loggerName: 'studio-foundations.i18n',
					teamName: 'studio',
				});
			}
		}

		return {
			default: Object.assign(
				{},
				defaultMessages,
				...results.flatMap((result) =>
					result.status === 'fulfilled' ? [result.value.default] : [],
				),
			),
		};
	};
};
